export default __webpack_public_path__ + "static/media/announcement_3.22fb21bf.png";